import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    value: {
        fontWeight: "bold",
        color: theme.palette.common.black,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "pre",
        "&:hover": {
            overflow: "visible",
            backgroundColor: theme.palette.common.white,
            width: "fit-content",
            position: "relative",
            zIndex: 1,
        },
    },
    gridValue: {
        "&.MuiGrid-item": {
            paddingLeft: 0,
        },
    },
    gridField: {
        display: "flex",
        "&.MuiGrid-item": {
            paddingRight: 0,
        },
    },
}));
